import { Row } from '@ydistri/ds';
import { computeRemSize } from '@ydistri/theme';
import { styled } from 'styled-components';
import { RuleSetCard } from '../../../components/domain/Scopes/ScopeSectionsStyledComponents';

export const ScopeControlRow = styled(Row)`
  align-items: center;
  flex-wrap: wrap;
  gap: ${computeRemSize(8)};
  width: 100%;
`;

export const ScopeSelectContainer = styled.div`
  display: block;
  flex: 1 1 0;
  min-width: ${computeRemSize(320)};

  .ant-spin-nested-loading,
  .ant-spin-container {
    width: 100%;
  }
`;

export const ScopeCreateButtonSlot = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
`;

export const ScopeSharingButtonSlot = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
`;

export const ScopeSelectedValue = styled.span`
  align-items: center;
  display: flex;
  gap: ${computeRemSize(8)};
  min-width: 0;
  width: 100%;
`;

export const SharedScopeNotice = styled(RuleSetCard)`
  display: flex;
  flex-direction: column;
  gap: ${computeRemSize(10)};
  padding: ${computeRemSize(12)};
`;

export const SharedScopeNoticeHeader = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${computeRemSize(8)};
`;

export const SharedScopeNoticeMessage = styled.span`
  flex: 1 1 auto;
`;

export const SharedScopeUsageList = styled.ul`
  margin: 0;
  padding-left: ${computeRemSize(24)};
`;
